<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid admin-dashboard">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <app-admin-sidebar></app-admin-sidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div :style="{ margin:'80px' }">
                <div class="card">
                  <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
                    <b style="flex: 1; text-align: left;">Configure Clients Account Statement</b>
                    <a href="https://crontab.guru/" target="_blank" style="flex: 1; text-align: center;">Link to generate cron expression</a>
                    <a href="https://chat.openai.com/" target="_blank" style="flex: 1; text-align: right;">Generate using ChatGPT</a>
                  </div>

                <div class="card-body">
                    <form>
                      <div class="row">
                        <div class="col">
                          <b style="text-transform: capitalize;">Clients:</b>
                          <select class="form-control " id="clients-dropdown" v-model="clientIds" multiple >
                            <option v-for="data in allClients" :value="data.clientId.toString()" :key="data.clientId">{{ data.clientName }}</option>
                          </select>
                        </div>
                        <div class="col">
                          <b style="text-transform: capitalize;">Expression</b>
                          <input
                            type="text"
                            class="form-control"
                            v-model="expression"
                            placeholder="Enter cron expression"
                          />
                        </div>
                      </div>
                      <div class="row pt-2 text-center">
                        <div class="col">
                          <button class="btn btn-primary" type="button" :disabled="isDisabled" @click="configureClientAccountStatment()">Add
                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                          </button>
                        </div>
                      </div>
                    </form>
                </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <table class="table table-hover table-striped mb-2">
                            <thead>
                                <tr>
                                    <th>Client Id</th>
                                    <th>Client Name</th>
                                    <th>Cron Expression</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="client in congiuredClientList" :key="client.clientId">
                                    <td>{{ client.clientId }}</td>
                                    <td>{{ client.clientName }}</td>
                                    <td>{{ client.account_statment_cron_expression }}</td>
                                    <td><a href="javascript:void(0)" @click="deleteClientCronConfiguration(client.clientId)"><i class="fas fa-trash text-danger"></i></a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="text-center mb-4">
                  <img 
                    :src="sampleImage" 
                    alt="Sample Template" 
                    class="img-fluid" 
                    style="max-width: 35%; height: auto; margin: 0 auto;" 
                  />
                </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import DashboardService from "../../services/DashboardService"

export default {
  name: "divvyAdminDashboard",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
  },
  data() {
    return {
        isDisabled: false,
        sassFeesFile: "",
        successMessage: "",
        errorMessage: "",
        allClients: [],
        clientIds: [],
        expression: null,
        congiuredClientList: [],
        sampleImage: require("../../assets/sample_template.png"),
    }
  },
  methods: {
      async getAllClients() {
      let data = {
        }
        await DashboardService.getAllClients()
        .then((response) => {
            this.isDisabled = false;
            if (response.status == 200) {
              this.allClients = response.data
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
          this.isDisabled = false;
          alert(e.response.data.message);
        });
      },
      async configureClientAccountStatment() {
        this.isDisabled = true
        let data = {
              cron_expression: this.expression,
              client_ids: this.clientIds,
          }
          await DashboardService.configureClientAccountStatment(data)
          .then((response) => {
              this.isDisabled = false;
              if (response.status == 200) {
                this.getcongiuredClientList();
                alert(response.data.message)
                this.clientIds = [];
                this.cron_expression = ""
              } else {
                  alert(response.data.error)
              }
          }).catch((e) => {
            this.isDisabled = false;
            alert(e.response.data.message);
          });
      },
      async getcongiuredClientList() {
        let data = {
          cron_expression: true
        }
        await DashboardService.getAllClients(data)
        .then((response) => {
            this.isDisabled = false;
            if (response.status == 200) {
              this.congiuredClientList = response.data
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
          this.isDisabled = false;
          alert(e.response.data.message);
        });
      },
      async deleteClientCronConfiguration(clientId) {
        let data = {
          client_ids: [clientId.toString()]
        }
        await DashboardService.configureClientAccountStatment(data)
        .then((response) => {
            if (response.status == 200) {
              this.getcongiuredClientList();
              alert(response.data.message)
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
          alert(e.response.data.message);
        });
      }
  },
  beforeMount() {
    this.getAllClients();
    this.getcongiuredClientList();
  },
  mounted() {
     $('#clients-dropdown').select2({
        placeholder: "Select Client",
        theme: "classic",
        //closeOnSelect: false,
      }).on('select2:select', (e) => {
        this.clientIds.push(e.params.data.id)
        console.log(this.clientIds);
      }).on('select2:unselect', (e) => {
        this.clientIds = this.clientIds.filter(item => item !== e.params.data.id)
        console.log(this.clientIds);
      });
  }
};
</script>

